import React, { useState } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { CircularProgress } from '@mui/material';

import { ConfirmDialog } from '@internal/components/application-view/withdraw-dialog.styled';

import {
  BlackActionButton,
  DeclineCommentField,
  DeclineDialogBody,
  DeclineDialogFooter,
  DialogCloseButton,
  DialogHeader,
  DialogHeading,
  OutlineActionButton,
} from './project-view.styled';

interface DeclineOfferDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
}

const DeclineOfferDialog: React.FC<DeclineOfferDialogProps> = ({
  open,
  loading,
  onClose,
  onConfirm,
}) => {
  const [comment, setComment] = useState('');

  const close = () => {
    setComment('');
    onClose();
  };

  return (
    <ConfirmDialog open={open} onClose={close}>
      <DialogHeader>
        <DialogHeading>Thanks for sharing your preferences</DialogHeading>
        <DialogCloseButton type="button" aria-label="Close" onClick={close}>
          <CloseRoundedIcon />
        </DialogCloseButton>
      </DialogHeader>

      <DeclineDialogBody>
        Please comment on what is missing here so we could make a better choice
        next time.
      </DeclineDialogBody>

      <DeclineCommentField
        value={comment}
        onChange={event => setComment(event.target.value)}
        placeholder="Your comment"
        data-testid="project-decline-comment"
      />

      <DeclineDialogFooter>
        <OutlineActionButton
          type="button"
          onClick={close}
          data-testid="project-decline-cancel"
        >
          Cancel
        </OutlineActionButton>
        <BlackActionButton
          type="button"
          disabled={loading}
          onClick={() => onConfirm(comment)}
          data-testid="project-decline-confirm"
        >
          {loading ? (
            <CircularProgress color="inherit" size={14} />
          ) : (
            'Decline offer'
          )}
        </BlackActionButton>
      </DeclineDialogFooter>
    </ConfirmDialog>
  );
};

export default DeclineOfferDialog;
